import { format } from 'date-fns';
import { AssetServiceValue, TimeStepValues, weekDayOptions } from './consts';

export const toWeekdays = (work_time: Record<string, any>) => weekDayOptions.filter((day) => work_time[day.value]);

export const mapServices = (
  services: {
    type_of_asset: string;
    type_of_repairs: string[];
  }[]
): AssetServiceValue[] => {
  if (services.length === 0) {
    return [
      {
        type_of_asset: null,
        type_of_repairs: [],
      },
    ];
  }
  return services.map((service) => ({
    type_of_asset: service.type_of_asset
      ? {
          label: service.type_of_asset,
          value: service.type_of_asset,
        }
      : null,
    type_of_repairs: service.type_of_repairs.map((r) => ({
      label: r,
      value: r,
    })),
  }));
};

export const mapToWorkSchedule = (time: TimeStepValues) => {
  const activeDays = new Set(time.weekdays?.map((d) => d.value));

  return {
    start_time: time.start_time ? format(time.start_time, 'HH:mm') : '',
    end_time: time.end_time ? format(time.end_time, 'HH:mm') : '',
    monday: activeDays.has('monday'),
    tuesday: activeDays.has('tuesday'),
    wednesday: activeDays.has('wednesday'),
    thursday: activeDays.has('thursday'),
    friday: activeDays.has('friday'),
    saturday: activeDays.has('saturday'),
    sunday: activeDays.has('sunday'),
  };
};
